import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const {clientauth} = useAuth()

	return (
        <>
            <div className="mb-4">
                <h1 className="h3">{t('admin.dashboard.welcome')}, {clientauth?.username}</h1>
                <p className="text-muted mt-2" style={{ fontSize: '15px' }}>{t('admin.dashboard.subtitle')}</p>
            </div>

            <Row className="g-4">
                <Col xs={12} md={6}>
                    <Link to={`/${clientauth?.rol}/products`} className="text-decoration-none">
                        <div className="kpi-card">
                            <div className="kpi-icon" style={{ background: '#EEF2FF', color: '#4F46E5' }}>
                                <i className="fas fa-barcode"></i>
                            </div>
                            <div>
                                <div className="kpi-value">{t('admin.dashboard.products')}</div>
                                <div className="kpi-label">{t('admin.dashboard.manageProducts')}</div>
                            </div>
                        </div>
                    </Link>
                </Col>
            </Row>
        </>
	)
}
